module.exports = __webpack_public_path__ + "cl.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/cl.svg
// module id = 748
// module chunks = 0